import { Config } from 'tailwindcss';
import { DefaultColors } from 'tailwindcss/types/generated/colors';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig, { theme } from '../../tailwind.config';

const tailwindResolvedConfig = resolveConfig(
  tailwindConfig as unknown as Config,
);

type CustomColorsType = typeof theme.extend.colors;

type ThemeType = typeof tailwindResolvedConfig.theme & {
  colors: DefaultColors & CustomColorsType;
};

const { theme: tw } = tailwindResolvedConfig as {
  theme: ThemeType;
};

export default () => tw;
